export const COMPARE_PAGES = Object.freeze([
  { slug: "circle", name: "Circle" },
  { slug: "discourse", name: "Discourse" },
  { slug: "mighty-networks", name: "Mighty Networks" }
]);

export const COMPARE_SLUGS = Object.freeze(COMPARE_PAGES.map(page => page.slug));

export const COMPARE_PATH_PREFIX = "/compare/";

export const comparePath = slug => `${COMPARE_PATH_PREFIX}${slug}`;

export function isComparePath(pathname = "") {
  if (!pathname.startsWith(COMPARE_PATH_PREFIX)) return false;
  return COMPARE_SLUGS.includes(pathname.slice(COMPARE_PATH_PREFIX.length));
}

export function loadComparePage(slug) {
  if (!COMPARE_SLUGS.includes(slug)) return Promise.resolve(null);
  return import(/* webpackChunkName: "compare-[request]" */ `./pages/${slug}.json`).then(
    module => module.default || module
  );
}
